module.exports = __webpack_public_path__ + "img/logo_extended.58338880.png";